import { Article } from '@generated'

type Props = {
  data: Article
}

export function getProductAvailability({ data }: Props): string {
  let availability = 'https://schema.org/OutOfStock'

  if (data.inStock) {
    if (data.isWebShopOnly) {
      availability = 'https://schema.org/OnlineOnly'
    } else {
      availability = 'https://schema.org/InStock'
    }
  }

  return availability
}
